module.exports = __webpack_public_path__ + "static/media/grid-item-b9.042d2f42.png";